{
	"closeOption": {
		"title": "Close Position",
		"sharesPerContract": "x 100 shares",
		"pcs": "pcs",
		"quantity": "Quantity",
		"side": {
			"buy": "Buy",
			"sell": "Sell"
		},
		"sum": "Amount",
		"stocks": "Shares",
		"closePosition": "Close Position",
		"availableMoney": "Available Funds",
		"orderType": "Order Type",
		"price": "Price",
		"bid": "Bid",
		"ask": "Ask",
		"closeOptionSuccess": "Close position order successfully placed",
		"closeOptionReject": "An error occurred while closing the position",
		"optionContractDetailReject": "Option contract details could not be obtained",
		"marketNotOpenedReject": "Wait for the market to open",
		"closeNotAvailable": "Closing a position with a Market order is currently unavailable"
	}
}
